// extracted by css-extract-rspack-plugin
export default {"account":"GVacvZ"};